/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import ButtonGroup from "../ui/ButtonGroup";
import Button from "../ui/Button";
import { ROUTES } from "../../constants/constants";
import { useNavigate } from "react-router-dom";


const ClientLoginView = ({ onLoginClick, allowRegistration }) => {
  const navigate = useNavigate();

  const navigateToRegister = () => {
    navigate(ROUTES.CLIENT_REGISTER)
  }

  return (
    <ButtonGroup justify="center" itemsWidth="full">
      {allowRegistration && (
        <Button variant="outline" title="Sign up" onClick={navigateToRegister} />
      )}
      <Button variant="primary" title="Log in" onClick={onLoginClick} />
    </ButtonGroup>
  );
};

export default ClientLoginView;
